import React, { useState, useEffect } from "react";
import { Box, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PageTitle from "../../commoncomponents/PageTitle";
import { DefaultCard } from "../../../assets/styled-components/card";
import SectionTitle from "../../commoncomponents/SectionTitle";
import RefreshExportButtons from "../../commoncomponents/RefreshExportButtons";
import CustomAgGrid from "../../commoncomponents/CustomAgGrid";
import CloseButton from "../../commoncomponents/CloseButton";
import utilities from "../../../utility/utilities";
import { useAccess } from "../../../AccessContext";
import { BemsGraph } from "../../../utility/apiURLS";
import { getAuthToken, getcompanyId, getFacilityId, getuserId } from "../../../utility/tokenUtility";
import { ErrorChips, SuccessChips, WarningChips } from "../../../assets/styled-components/chips";

const BemsAssetMedicalRisk = () => {

    const [rows, setRows] = useState([]);
    const [gridApi, setGridApi] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const accessData = useAccess();
    // const access = utilities.getScreenPermissions(accessData, "ENGM014");

    const columns = [
        { field: "facilityname", headerName: "Hospital Name", width: 180 },
        { field: "assetNo", headerName: "Asset No", width: 150 },
        { field: "checklistStatus", headerName: "Checklist Status", width: 150, wrapHeaderText: false },
        { field: "assetDescription", headerName: "Asset Description", width: 180, wrapHeaderText: false },
        {
            field: "lifespan", headerName: "Lifespan", width: 180,
            filter: 'agNumberColumnFilter',

            filterParams: {
                // 1. Force AG Grid to only show a single filter condition block
                maxNumConditions: 1,

                // 2. Keep 'Between' (inRange) as your primary option
                filterOptions: ['inRange', 'greaterThan', 'lessThan', 'equals'],
                defaultOption: 'inRange',

                // 3. Action buttons
                buttons: ['apply', 'clear', 'reset'],
                closeOnApply: true
            }
        },
        {
            field: "assetAge", headerName: "Asset Age", width: 150,
            filter: 'agNumberColumnFilter',

            filterParams: {
                // 1. Force AG Grid to only show a single filter condition block
                maxNumConditions: 1,

                // 2. Keep 'Between' (inRange) as your primary option
                filterOptions: ['inRange', 'greaterThan', 'lessThan', 'equals'],
                defaultOption: 'inRange',

                // 3. Action buttons
                buttons: ['apply', 'clear', 'reset'],
                closeOnApply: true
            }
        },
        { field: "assetRisk", headerName: "Asset Risk", width: 180 },
        {
            field: "assetRiskLevel", headerName: "Asset Risk Level", cellRenderer: (params) => {
                if (params?.value === "Low Risk") {
                    return <SuccessChips label={params.value} />;
                } else if (params?.value === "Moderate Risk") {
                    return <WarningChips label={params.value} />;
                } else if (params?.value === "High Risk") {
                    return <ErrorChips label={params.value} />
                }
            }, wrapHeaderText: false
        },
        { field: "assetRiskCondition", headerName: "Asset Risk Condition", width: 180, wrapHeaderText: false },
        { field: "commissoingDate", headerName: "Commissioning Date", width: 150, wrapHeaderText: false },
        { field: "brand", headerName: "Brand", width: 150 },
        { field: "model", headerName: "Model", width: 180 },
        { field: "serialNumber", headerName: "Serial No", width: 150 },
        { field: "manufacturer", headerName: "Manufacturer", width: 180 },
        { field: "userDescription", headerName: "Department Description", width: 150, wrapHeaderText: false },
        { field: "userLocationDesc", headerName: "Location Name", width: 180, wrapHeaderText: false },
        { field: "assetStatus", headerName: "Real Time Status", width: 150, wrapHeaderText: false }
    ];

    useEffect(() => {
        fetchBemsAssetRiskList();

    }, []);

    const fetchBemsAssetRiskList = async () => {
        setRows([]);
        setIsLoading(true);
        try {
            const token = getAuthToken("id_token");
            const userId = getuserId("userId");
            const companyId = getcompanyId("companyId");
            const facilityId = getFacilityId("facilityId");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            const url = `${BemsGraph}/api/GraphAssetregister/GetBemasserisklist/${companyId}/${userId}/${facilityId}/${token}`;

            const response = await axios.get(url, config);

            setRows(response?.data);


        } catch (error) {
            //  console.error("Error fetching user departments:", error);
        } finally {
            setIsLoading(false);
        }
    };


    const handleRefresh = () => {
        fetchBemsAssetRiskList();
    };




    return (
        <>
            <Box mt={{ xs: 1, sm: 2 }}>
                <PageTitle title={`Asset Risk Management List ≥ 10 Years`} />
                <DefaultCard>
                    <Box
                        mb={1}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                        }}
                    >
                        <SectionTitle title={`Asset Risk Management List ≥ 10 Years`} />
                        <Stack direction={"row"} spacing={1.5}>

                            <RefreshExportButtons
                                exportFunction={() => { }}
                                exportData={rows}
                                refData={gridApi}
                                handleRefresh={handleRefresh}
                                title={`Asset Risk Management List ≥ 10 Years`}

                            />
                        </Stack>
                    </Box>
                    <CustomAgGrid
                        rows={rows}
                        columns={columns}
                        ref={gridApi}
                        setGridApi={setGridApi}
                        pagination={true}
                        isLoading={isLoading}
                    />
                </DefaultCard>
            </Box>

            <CloseButton />
        </>
    );
};

export default BemsAssetMedicalRisk;
